module.exports = __webpack_public_path__ + "static/img/icon-training2.3f27ea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-training2.png
// module id = fvu1
// module chunks = 21